import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Breadcrumb, BreadcrumbItem} from "mdbreact";
import {Link} from "react-router-dom";
import Product from "../../components/product/Product";
import axios from "axios/index";
import {API_URL} from "../../config/Config";
// import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import axiosRetry from 'axios-retry';
import PageLoader from "../../components/loader/PageLoader";

import "./../../assets/images/banner-products.jpg";

axiosRetry(axios, { retries: 3 });


class Products extends Component {
    constructor(props) {
        super(props);
        this.state = {
            city: 'تهران',
            city_id: '1',
            ready:false,
            products:[],
            loading:false,
            notFound:''
        };
    }

    async componentDidMount() {
        await this.getProductsList();
    }

    async getProductsList() {
        this.setState({loading: false});
        try {
            let response = await axios.get(`${API_URL}cart-by-cat/${this.state.city_id}`);
            let products = await response.data.data;
            console.log(products)
            this.setState({products});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
                if (apiError.status === 404){
                    this.setState({
                        notFound:'دسته بندی نا مشخص'
                    })
                }
            }
        }
        this.setState({loading: true});
    }


    async handelChangeCity(event){
        await this.setState({
            city: event.target.options[event.target.selectedIndex].text,
            city_id: event.target.value
        });
        await this.getProductsList();

    }
    render() {

        return (
            <div >
                <div className="jumbotron text-center rtl products-page-header">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5 ">
                        <div className="p-2 text-right rtl">
                            {/*<h1 className="pag-title">محصولات</h1>*/}
                            {/*<p>این یک صفحه خالی است !</p>*/}
                            <select className="browser-default mt-3 p-1 border-dark" onChange={this.handelChangeCity.bind(this)} value={this.state.my_city_id}>
                                <option value="1">تهران</option>
                                <option value="2">اصفهان</option>
                                <option value="3">شیراز</option>
                                <option value="4">مشهد</option>
                                <option value="5">گیلان و مازندران</option>
                                <option value="6">کیش</option>
                                <option value="7">تبریز</option>
                            </select>
                            <br/>
                            <h2 className="mt-4" style={{color:"#32039e"}}>{this.state.my_city}</h2>

                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                <BreadcrumbItem active>محصولات</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            {!this.state.loading? <PageLoader type="spinningBubbles" color="#f6581d" />:
                                <div>
                                    {this.state.products.length===0?<p className="w-100 text-center">موردی یافت نشد</p>:``}

                                    {this.state.products.map(product =>
                                        <Product productObj={product} key={product.id}/>
                                    )}

                                </div>
                            }
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(Products);



// WEBPACK FOOTER //
// ./src/containers/products/Products.js